"use client"

import Page500 from "components/pages/error/500Page"
import { useEffect } from "react"

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("App error:", error)
  }, [error])

  // If Page500 supports a "try again" button, you can pass reset down as a prop.
  return <Page500 />
}
